// filepath: frontend/src/components/brand/PotopodWordmark.tsx
interface PotopodWordmarkProps {
  className?: string;
  withTagline?: boolean;
  tagline?: string;
  dark?: boolean;
}

export function PotopodWordmark({
  className = '',
  withTagline = false,
  tagline = 'Powered by RDL Eagle Trade',
  dark = true,
}: PotopodWordmarkProps) {
  const wordFill = dark ? '#F5F7FB' : '#0C1626';
  const taglineFill = dark ? 'rgba(255,255,255,0.42)' : 'rgba(12,22,38,0.56)';

  return (
    <div className={`inline-flex flex-col ${className}`}>
      <svg
        viewBox="0 0 640 140"
        role="img"
        aria-label="POTOPOD"
        className="h-auto w-full"
        style={{ shapeRendering: 'geometricPrecision' }}
      >
        <text
          x="18"
          y="91"
          fill={wordFill}
          fontSize="96"
          fontWeight="900"
          letterSpacing="-0.105em"
          style={{ fontFamily: 'Helvetica Neue, Arial, sans-serif' }}
        >
          POT
        </text>

        <text
          x="256"
          y="91"
          fill={wordFill}
          fontSize="96"
          fontWeight="900"
          letterSpacing="-0.105em"
          style={{ fontFamily: 'Helvetica Neue, Arial, sans-serif' }}
        >
          POD
        </text>

        <g transform="translate(228 56.5)">
          <circle r="34" fill={wordFill} />
          <circle r="25.8" fill="#1FA7D7" />
          <circle r="17.4" fill="#F39A45" />
          <circle r="11.1" fill="#0F223B" />
          <text
            x="0"
            y="3.4"
            textAnchor="middle"
            fontSize="8.5"
            fontWeight="700"
            fill="#FFFFFF"
            style={{ fontFamily: 'Helvetica Neue, Arial, sans-serif', letterSpacing: '0.08em' }}
          >
            RDL
          </text>
        </g>
      </svg>

      {withTagline ? (
        <span
          className="mt-2 text-[11px] uppercase tracking-[0.28em]"
          style={{ color: taglineFill }}
        >
          {tagline}
        </span>
      ) : null}
    </div>
  );
}
